import 'css/src/components/dashboard/ProjectIcon.module.scss';

import React from 'react';

type Props = {
    iconName?: string;
    iconColor?: string;
    iconBgColor?: string;
    iconClassName?: string;
};

const ProjectIcon: React.FC<Props> = React.memo(function ProjectIcon({
    iconName = 'folder',
    iconColor = '#fff',
    iconBgColor = 'transparent',
    iconClassName = '',
}) {
    return (
        <>
            <i
                className={`material-symbols-outlined project-icon ${iconClassName}`}
                style={{
                    color: `${iconColor}`,
                    backgroundColor: `${iconBgColor}`,
                }}
            >
                {iconName}
            </i>
        </>
    );
});

export default ProjectIcon;
